
<div class="email-wrapper">

  <!-- Email Verfication Banner -->
  @if (implRef.showVerificationBanner) {
    <div class="email-verification-banner">
      <div class="banner-main">
        <span class="banner-text">Protect your account by verifying your email, <a  (click)="verifyNow()" style="text-decoration: underline;" rel="noopener noreferrer">Verify now.</a></span>
        <!-- <span class="NeueFile_Cancel close-banner" (click)="hideEmailVerificationBanner()"></span> -->
      </div>
    </div>
  }


  <!-- Email Verification Modal -->
  <div class="modal fade emailModal" id="emailModal"  aria-labelledby="myModalLabel"
    [ngStyle]="{'display': this.universalService.isShowEmailVerifyModal? 'block' : 'none', 'left':0,'right':0,'opacity': 1,'background' : 'rgba(0,0,0,0.5)','backdrop-filter':'blur(10px)', 'transition':'all ease-in .1s'}" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document" [ngStyle]="{'max-width':!this.universalService.isMobileDevice?'900px' : '100%'}">
      <div class="modal-content">
        <div class="modal-body">
          <!-- Content Starts -->
          <div class="content">
            @if (this.universalService.isPhoneVerification || !implRef.isMandatoryEmailActive) {
              <button type="button" class="close btn-pos d-none d-lg-block" data-dismiss="modal" aria-hidden="true" (click)="closeEmailVerifyModal()" >
                <span class="NeueFile_Cancel"></span>
                <span class="esc">esc</span>
              </button>
            }
            <div class="row">
              <div class="col-xs-12 d-none d-md-block col-md-4 graphic-main">
                <div class="">
                  <img src="https://static.jiocloud.com/web2.0/common/images/jc-account-safety.svg" class="img-fluid" alt="JioAICloud Account Safety Banner" />
                </div>
              </div>

              <!-- email verification starts -->
              @if (!this.universalService.isPhoneVerification) {
                <div class="col-xs-12 col-md-8">
                  <button type="button" class="close modal-close d-md-none Neueclosefilled" data-dismiss="modal" aria-hidden="true" [hidden]="implRef.isMandatoryEmailActive" (click)="closeEmailVerifyModal()"></button>
                  <div class="otp-to-email-main" [hidden]="!implRef.showValidateEmailScreen">
                    <h1>Hello {{this.universalService.firstName}}, <br> <br> Help us keep your account safe.</h1>
                    <p>For security of your account, you need to verify your email.</p>
                    <span class="note-txt">A verified email will help you recover your data even without your mobile number.</span>
                    <div class="send-otp-form">
                      <form action="" class="">
                        <input #emailInput type="text" class="email-txtbx" id="email-txtbx" autocomplete="off"
                          placeholder="Enter email" [formControl]="userEmail"  (keyup)="clearError(emailInput)"  maxlength="100"/>
                        <!--
                        pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$"
                        -->
                        @if (implRef.showOtpError==true && !inputInvalid) {
                          <div class="err-msg visible-inline-block-lg mb-2" >
                            <span class="NeueAlert"></span> {{implRef.showOtpErrorMsg}}
                          </div>
                        }
                        <span class="emailErrorCont"  data-toggle="tooltip" title="Invalid Email"
                          [hidden]="(!this.inputInvalid) || emailInput.value.length==0"  >
                          <div class="tooltip1"  data-toggle="tooltip" title="Invalid Email">
                            <span class="NeueAlert"></span>
                          </div>
                        </span>
                        <span class="emailErrorCont" [hidden]="emailInput.value.length>0">
                          <div class="tooltip1">
                            <span class="NeueAlert" data-toggle="tooltip" title="Enter Email"></span>
                          </div>
                        </span>
                        <div class="btn-wrap">
                          <button class="btn btn-send-otp" (click)="sendEmailVerificationOtp('email')" [disabled]="inputInvalid">Send OTP on email</button>
                          <button type="button" class="visible-inline-block-xl otp-link" [disabled]="inputInvalid" (click)="alreadyHaveOtp('email')">Already have OTP</button>
                        </div>
                      </form>
                    </div>
                  </div>
                  <!-- Modal Content Holder -->
                  @if (implRef.showInputOtpScreen) {
                    <div class="otp-to-email-main verify-email-main" >
                      <h1><span class="NeueExit-Folder visible-inline-block-xs d-block d-md-none" (click)="changeEmail()"></span>Verify email</h1>
                      <p class="spaceElement"></p>
                      <!-- <p >OTP sent to {{userEmail.value}}</p> -->
                      <p>OTP sent to</p>
                      <span  class="email-txt">{{userEmail.value}}</span>
                      <!-- <span  class="email-txt"></span> -->
                      <a title="Click to change email" class="d-none d-md-inline-block otp-link changeMailLink" (click)="changeEmail()" rel="noopener noreferrer">Change</a>
                      <div class="send-otp-form">
                        <fieldset role="form">
                          <form name="otpForm" class="digit-group" id="otpInputForm" data-group-name="digits" data-autosubmit="false" autocomplete="off">
                            <span><input id="digit1" aria-labelledby="otp input" oninput="this.value = this.value.replace(/[^0-9]/g, '')" type="password" class="enterOtp" data-next="digit2" maxlength="1"
                              inputmode="numeric" (keyup)="validateOTP('digit1','digit2',$event)" name="otpdigit[]" />
                          </span>
                          <span><input id="digit2" oninput="this.value = this.value.replace(/[^0-9]/g, '')" type="password" class="enterOtp" data-next="digit3" data-previous="digit1"
                            maxlength="1" inputmode="numeric" (keyup)="validateOTP('digit2','digit3',$event)"
                            name="otpdigit[]" />
                        </span>
                        <span><input id="digit3" oninput="this.value = this.value.replace(/[^0-9]/g, '')" type="password" class="enterOtp" data-next="digit4" data-previous="digit2"
                          maxlength="1" inputmode="numeric" (keyup)="validateOTP('digit3','digit4',$event)"
                          name="otpdigit[]" />
                      </span>
                      <span><input id="digit4" oninput="this.value = this.value.replace(/[^0-9]/g, '')" type="password" class="enterOtp" data-next="digit5" data-previous="digit3"
                        maxlength="1" inputmode="numeric" (keyup)="validateOTP('digit4','digit5',$event)"
                        name="otpdigit[]" />
                    </span>
                    <span><input id="digit5" oninput="this.value = this.value.replace(/[^0-9]/g, '')" type="password" class="enterOtp" data-next="digit6" data-previous="digit4"
                      maxlength="1" inputmode="numeric" (keyup)="validateOTP('digit5','digit6',$event)"
                      name="otpdigit[]" />
                  </span>
                  <span><input id="digit6" oninput="this.value = this.value.replace(/[^0-9]/g, '')" type="password" class="enterOtp" data-previous="digit5" maxlength="1"
                    inputmode="numeric" (keyup)="validateOTP('digit6','null',$event)" name="otpdigit[]" />
                </span>
                <!-- Error Message -->
                @if (implRef.showOtpError == true && implRef.showOtpErrorMsg) {
                  <div class="err-msg visible-inline-block-lg">
                    <span class="NeueAlert"></span> {{implRef.showOtpErrorMsg}}
                  </div>
                }
                <!-- Button -->
                <div class="btn-wrap">
                  <button type="button" class="btn btn-send-otp verifyEmailBtn" (click)="verifyEmailVerificationOTP('email')"  [disabled]="!this.implRef.enableButton">Verify Email</button>
                  <div class="resend-otp">
                    <a title="Click to resend OTP" (click)="resendEmailVerifyOtp('email')" rel="noopener noreferrer">Resend OTP</a>
                  </div>
                </div>
              </form>
            </fieldset>
          </div>
        </div>
      }
      @if (implRef.showsuccessullyValidatedScreen) {
        <div class="otp-to-email-main thank-you-main" >
          <h1>
          Thank you for verifying your email.</h1>
          <!-- <h1 class="storageMsg">You've unlocked a bonus storage. We shall update it shortly.</h1> -->
          <!-- Thank You Content -->
          <div class="thank-you-cont">
            <h2>Benefits of verified email address.</h2>
            <ul>
              <li>Get notified for shared files</li>
              <li>Manage logins on other devices</li>
              <li>Never miss important updates</li>
              <li>Never lose access to your account</li>
            </ul>
          </div>
          <!-- Button -->
          <div class="btn-wrap">
            <button class="btn btn-send-otp" data-dismiss="modal" (click)="closeEmailVerifyModal()">Enjoy JioAICloud</button>
          </div>
        </div>
      }
    </div>
  }



  <!-- Mobile no verification starts -->
  @if (this.universalService.isPhoneVerification) {
    <div class="col-xs-12 col-md-8">
      <button type="button" class="close modal-close d-md-none Neueclosefilled" data-dismiss="modal" aria-hidden="true" (click)="closeEmailVerifyModal()"></button>
      <div class="otp-to-email-main" [hidden]="!implRef.showValidateEmailScreen">
        <h1>Hello {{this.universalService.firstName }}, <br><br> Help us keep your account safe.</h1>
        <p>For the security of your account, we need to verify your phone number.</p>
        <span class="note-txt">The presence of a verified phone number assures both account security and a reliable communication channel.</span>
        <div class="send-otp-form">
          <form [formGroup]="userMobileForm" action="" class="">
            <input #mobileInput  pattern="[0-9]*" type="text" class="user-no-txtbx" id="user-no-txtbx" autocomplete="off"
              placeholder="E&zwnj;nter p&zwnj;hone n&zwnj;umber" formControlName="userMobile"  (keyup)="clearMobileNoError(mobileInput)"  maxlength="10" oninput="this.value=this.value.replace(/[^0-9]/g,'');"/>
            @if (implRef.showOtpError==true) {
              <div class="err-msg visible-inline-block-lg mb-2" >
                <span class="NeueAlert"></span> {{implRef.showOtpErrorMsg}}
              </div>
            }
            @if (mobileInput?.value.length <= 9) {
              <span class="emailErrorCont"  data-toggle="tooltip" title="Invalid Phone No"
                >
                <div class="tooltip1"  data-toggle="tooltip" title="Invalid Phone No">
                  <span class="NeueAlert"></span>
                </div>
              </span>
            }
            <div class="btn-wrap">
              <button class="btn btn-send-otp" (click)="sendEmailVerificationOtp('phone')" [disabled]="mobileInput?.value.length <= 9">Send OTP on phone</button>
              <button type="button" class="visible-inline-block-xl otp-link" [disabled]="mobileInput?.value.length <= 9" (click)="alreadyHaveOtp('phone')">Already have OTP</button>
            </div>
          </form>
        </div>
      </div>
      <!-- Modal Content Holder -->
      @if (implRef.showInputOtpScreen) {
        <div class="otp-to-email-main verify-email-main" >
          <h1><span class="NeueExit-Folder visible-inline-block-xs d-block d-md-none" (click)="changeEmail()"></span>Verify Phone Number</h1>
          <p class="spaceElement"></p>
          <!-- <p >OTP sent to {{userMobile.value}}</p> -->
          <p >OTP sent to</p>
          <span  class="email-txt">{{mobileInput.value}}</span>
          <!-- <span  class="email-txt"></span> -->
          <a title="Click to phone number" class="d-none d-md-inline-block otp-link changeMailLink" (click)="changeEmail()" rel="noopener noreferrer">Change</a>
          <div class="send-otp-form">
            <form name="otpForm" class="digit-group"  id="otpInputForm" data-group-name="digits" data-autosubmit="false" autocomplete="off">
              <span><input id="digit1" oninput="this.value = this.value.replace(/[^0-9]/g, '')" type="password" class="enterOtp" data-next="digit2" maxlength="1"
                inputmode="numeric" (keyup)="validateOTP('digit1','digit2',$event)" name="otpdigit[]" />
            </span>
            <span><input id="digit2" oninput="this.value = this.value.replace(/[^0-9]/g, '')" type="password" class="enterOtp" data-next="digit3" data-previous="digit1"
              maxlength="1" inputmode="numeric" (keyup)="validateOTP('digit2','digit3',$event)"
              name="otpdigit[]" />
          </span>
          <span><input id="digit3" oninput="this.value = this.value.replace(/[^0-9]/g, '')" type="password" class="enterOtp" data-next="digit4" data-previous="digit2"
            maxlength="1" inputmode="numeric" (keyup)="validateOTP('digit3','digit4',$event)"
            name="otpdigit[]" />
        </span>
        <span><input id="digit4" oninput="this.value = this.value.replace(/[^0-9]/g, '')" type="password" class="enterOtp" data-next="digit5" data-previous="digit3"
          maxlength="1" inputmode="numeric" (keyup)="validateOTP('digit4','digit5',$event)"
          name="otpdigit[]" />
      </span>
      <span><input id="digit5" oninput="this.value = this.value.replace(/[^0-9]/g, '')" type="password" class="enterOtp" data-next="digit6" data-previous="digit4"
        maxlength="1" inputmode="numeric" (keyup)="validateOTP('digit5','digit6',$event)"
        name="otpdigit[]" />
    </span>
    <span><input id="digit6" oninput="this.value = this.value.replace(/[^0-9]/g, '')" type="password" class="enterOtp" data-previous="digit5" maxlength="1"
      inputmode="numeric" (keyup)="validateOTP('digit6','null',$event)" name="otpdigit[]" />
  </span>
  <!-- Error Message -->
  @if (implRef.showOtpError == true && implRef.showOtpErrorMsg) {
    <div class="err-msg visible-inline-block-lg">
      <span class="NeueAlert"></span> {{implRef.showOtpErrorMsg}}
    </div>
  }
  <!-- Button -->
  <div class="btn-wrap">
    <button type="button" class="btn btn-send-otp verifyEmailBtn" (click)="verifyEmailVerificationOTP('phone')"  [disabled]="!this.implRef.enableButton">Verify Phone</button>
    <div class="resend-otp">
      <a title="Click to resend OTP" (click)="resendEmailVerifyOtp('phone')" rel="noopener noreferrer">Resend OTP</a>
    </div>
  </div>
</form>
</div>
</div>
}
@if (implRef.showsuccessullyValidatedScreen) {
  <div class="otp-to-email-main thank-you-main" >
    <h1>Thank you for verifying your mobile number.</h1>
    <!-- <h1 class="storageMsg">You've unlocked a bonus storage. We shall update it shortly.</h1> -->
    <!-- Thank You Content -->
    <div class="thank-you-cont">
      <h2>Benefits of verified mobile phone.</h2>
      <ul>
        <li>Get notified for shared files</li>
        <li>Manage logins on other devices</li>
        <li>Never miss important updates</li>
        <li>Never lose access to your account</li>
      </ul>
    </div>
    <!-- Button -->
    <div class="btn-wrap">
      <button class="btn btn-send-otp" data-dismiss="modal" (click)="closeEmailVerifyModal()">Enjoy JioAICloud</button>
    </div>
  </div>
}
</div>
}
</div>
</div>
</div>
</div>
</div>
</div>

</div>